<template>
	<div class="lifestyle analysis">
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="card">
					<h5>Records</h5>
					<WaterTable :water="water"></WaterTable>
				</div>
			</el-col>
			
		</el-row>
	</div>
</template>
<script>
import WaterAnalysis from '.'
import WaterTable from './Table'

export default {
	name: 'lifestyle-card-water-analysis',
	extends: WaterAnalysis,

	components: {
		WaterTable
	}
}
</script>
<style lang="scss" scoped>
@import "../../component/table/style/analysis.scss";
</style>
